import { render } from "./CCOPatientNavigationScheduling.vue?vue&type=template&id=5fe64fae&scoped=true&lang=pug"
import script from "./CCOPatientNavigationScheduling.vue?vue&type=script&lang=js"
export * from "./CCOPatientNavigationScheduling.vue?vue&type=script&lang=js"

import "./CCOPatientNavigationScheduling.vue?vue&type=style&index=0&id=5fe64fae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe64fae"]])

export default __exports__